function getFormParent(el) {
  return el?.closest('.form-widget-form')?.parentElement;
}

function refreshSelectBox(select) {
  if (!select?.tagName === 'SELECT') return;

  let isActive = true;

  const placeholderOption = select.querySelector(
    'option:first-child[value=""]'
  );

  if (placeholderOption) {
    if (select.required) placeholderOption.disabled = true;
    if (!select.value) isActive = false;
  }

  if (isActive) {
    select.classList.add('active');
    select.classList.remove('inactive');
  } else {
    select.classList.add('inactive');
    select.classList.remove('active');
  }
}

function handleSelectChange(e) {
  refreshSelectBox(e.target);
}

function initSelectBoxes(form) {
  form.querySelectorAll('select').forEach(refreshSelectBox);

  // Clean up any potential existing event listeners
  form.removeEventListener('change', handleSelectChange);
  form.addEventListener('change', handleSelectChange);
}

document.querySelectorAll('.form-widget-form form').forEach(form => {
  form.noValidate = true;

  form.addEventListener('submit', e => {
    getFormParent(e.target)?.classList.add('form-initializing');
  });

  initSelectBoxes(form);
});

// Callback that runs every time Fremont Form Widget is rendered/updated
const prevInitFormCallback = window.__initForm;

window.__initForm = form => {
  form.noValidate = true;

  initSelectBoxes(form);

  const parentElement = getFormParent(form);

  if (parentElement) {
    parentElement.classList.remove('form-initializing');

    if (
      document.activeElement &&
      parentElement.contains(document.activeElement)
    ) {
      document.activeElement.blur();
    }
  }

  prevInitFormCallback?.(form);
};
